import { ScrollView, Text } from 'react-native'

export default function Page() {
  return (
    <ScrollView contentInsetAdjustmentBehavior="automatic">
      <Text>交易中心</Text>
    </ScrollView>
  )
}
